// Config utility to fetch and cache app configuration from backend
let configCache = null;
let configPromise = null;

export const getAppConfig = async () => {
  if (configCache) {
    return configCache;
  }

  if (configPromise) {
    return configPromise;
  }

  configPromise = fetch('/api/config')
    .then(response => response.json())
    .then(config => {
      configCache = config;
      return config;
    })
    .catch(error => {
      console.error('Failed to fetch app config:', error);
      // Return default config on error
      return {
        currencySymbol: 'RM',
        currencyCode: 'RM'
      };
    });

  return configPromise;
};

export const getCurrencySymbol = async () => {
  const config = await getAppConfig();
  return config.currencySymbol || 'RM';
};